import React, {useCallback, useMemo} from 'react';
import clsx from 'clsx';

import Deadline from '../Deadline';
import TableDetail from '../TableDetail';
import CooldownTimer from '../CooldownTimer';
import {ReactComponent as TimeIcon} from '../../assets/image/payment-time.svg';

import {useTranslation} from 'react-i18next';

import {TimeVal} from '../../utils';

import styles from './CodCooldown.module.css';

interface CodCooldownProps {
  className?: string
  paymentStatus: any
  expectedTime: number //in seconds
}


const CodCooldown = (props: CodCooldownProps) => {
  const {t} = useTranslation();

  const timeFormatter = useCallback(({days, hours, minutes}: TimeVal) => {
    const dayWord = days > 1 ? 'days' : 'day';
    const hourWord = hours > 1 ? 'hours' : 'hour';
    const minuteWord = minutes > 1 ? 'minutes' : 'minute';

    return `${days} ${t(dayWord)} ${hours} ${t(hourWord)} ${minutes} ${t(minuteWord)}`;
  }, [t]);

  const cooldownTo = useMemo(() => new Date((new Date()).toUTCString()).getTime(), []);

  return (
    <TableDetail className={clsx(styles.root, props.className)}>
      <div className={styles.processing}>
        <TimeIcon/>
        <span className={styles.status}>
          {t('processing')}
        </span>
      </div>
      <div className={styles.cooldown}>
        <CooldownTimer
          className={styles.cooldownText}
          time={props.expectedTime * 1000}
          timeFormatter={timeFormatter}
          cooldownTo={cooldownTo}
        />
      </div>
      <Deadline
        deadline={props.expectedTime}
        startString={t('payBefore')}
        separateDateTimeString={t('at')}
      />
    </TableDetail>
  );
};

export default CodCooldown;